import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import Settings from './Settings'
import { actions } from '../../store'

const mapStateToProps = state => ({
  user: state.user
})

const mapDispatchToProps = dispatch => bindActionCreators({
  updateUser: actions.user.updateUser,
  updateUserPassword: actions.user.updateUserPassword
}, dispatch)

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Settings)



// WEBPACK FOOTER //
// ./src/views/Settings/index.js